"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _configuratorModelSelector = require("@mmc/configurator-model-selector");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _actions = require("../actions");
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp;
var ModelSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ModelSelector, _React$Component);
  ModelSelector.sortByPrice = function sortByPrice(models) {
    var results = JSON.parse(JSON.stringify(models));
    results.sort(function (a, b) {
      return Number(handleNestedProp(a, 'a.price.value')) < Number(handleNestedProp(b, 'b.price.value')) ? -1 : 1;
    });
    return results;
  };
  ModelSelector.sortByCustomOrder = function sortByCustomOrder(models) {
    var results = JSON.parse(JSON.stringify(models));
    results.sort(function (a, b) {
      return Number(handleNestedProp(a, 'a.sortOrder')) - Number(handleNestedProp(b, 'b.sortOrder'));
    });
    return results;
  };
  function ModelSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.isTrimLineInsteadOfModelCode = props.hasAdditionalEquipmentStep;
    _this.changeEvent = _this.changeEvent.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = ModelSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var isTrimLineInsteadOfModelCode = this.isTrimLineInsteadOfModelCode,
      _this$props = this.props,
      model = _this$props.model,
      preferences = _this$props.preferences,
      data = _this$props.data,
      dispatch = _this$props.dispatch,
      hasModelsOrdering = _this$props.hasModelsOrdering;
    var models = data.models || [];
    var selectedModel = model;
    if (!isTrimLineInsteadOfModelCode) {
      // If the selected model is not valid set prefences or first to be selected
      if (!this.checkModelIsValid(selectedModel)) {
        selectedModel = preferences.model;
        if (!this.checkModelIsValid(selectedModel) && !isEmptyArray(models)) {
          var defaultSelectedModel = models.find(function (mod) {
            return mod.selected;
          });
          if (hasModelsOrdering) {
            var sortedModels = ModelSelector.sortByCustomOrder(models);
            selectedModel = sortedModels[0].code;
          } else if (defaultSelectedModel) {
            selectedModel = defaultSelectedModel.code;
          } else {
            var _sortedModels = ModelSelector.sortByPrice(models);
            selectedModel = _sortedModels[0].code;
          }
        }
        dispatch((0, _actions.setModel)(selectedModel));
      }
    }
    var queryString = typeof window !== 'undefined' && window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var fieldValue = urlParams.get('trimLine');
    if (fieldValue) {
      this.selectModel(fieldValue);
    }
  };
  _proto.checkModelIsValid = function checkModelIsValid(model) {
    var _this$props2 = this.props,
      data = _this$props2.data,
      hasModelsOrdering = _this$props2.hasModelsOrdering;
    var isValid = false;
    var models = data.models || [];
    var sortedModels = hasModelsOrdering ? ModelSelector.sortByCustomOrder(models) : ModelSelector.sortByPrice(models);
    if (model !== '' && model !== undefined && model !== null) {
      if (sortedModels.find(function (currentModel) {
        return currentModel.code === model;
      })) {
        isValid = true;
      }
    }
    return isValid;
  };
  _proto.sortByPreference = function sortByPreference(models) {
    var _this$props3 = this.props,
      fuelType = _this$props3.fuelType,
      transmissionType = _this$props3.transmissionType,
      driveType = _this$props3.driveType;
    var matches = [[], [], [], []];
    models.forEach(function (model) {
      var matchingStrength = 0;
      if (model.fuelType === fuelType) matchingStrength += 1;
      if (model.transmissionType === transmissionType) matchingStrength += 1;
      if (model.drivetrain === driveType) matchingStrength += 1;
      matches[matchingStrength].push(model);
    });

    // Only return the options that best match
    var results = [];
    for (var i = matches.length - 1; i >= 0; i -= 1) {
      if (!isEmptyArray(matches[i])) {
        results = matches[i];
        break;
      }
    }
    return ModelSelector.sortByPrice(results);
  };
  _proto.selectModel = function selectModel(selectedValue) {
    var isTrimLineInsteadOfModelCode = this.isTrimLineInsteadOfModelCode,
      _this$props4 = this.props,
      dispatch = _this$props4.dispatch,
      data = _this$props4.data;
    data.models.forEach(function (element) {
      if (element.trimLine === selectedValue) {
        dispatch((0, _actions.setModel)(element.code));
      }
    });
    if (isTrimLineInsteadOfModelCode) {
      dispatch((0, _actions.setTrimLine)(selectedValue));
    } else {
      dispatch((0, _actions.setModel)(selectedValue));
    }
  };
  _proto.changeEvent = function changeEvent(e) {
    this.selectModel(e.target.value);
  };
  _proto.render = function render() {
    var isTrimLineInsteadOfModelCode = this.isTrimLineInsteadOfModelCode,
      _this$props5 = this.props,
      selectedModel = _this$props5.model,
      market = _this$props5.market,
      data = _this$props5.data,
      _this$props5$theme = _this$props5.theme,
      theme = _this$props5$theme === void 0 ? {} : _this$props5$theme,
      addPriceDisclaimer = _this$props5.addPriceDisclaimer,
      priceDisclaimerId = _this$props5.priceDisclaimerId,
      disclaimerData = _this$props5.disclaimerData,
      hasModelsOrdering = _this$props5.hasModelsOrdering,
      direction = _this$props5.direction,
      trimLine = _this$props5.trimLine;
    var selectedItem = isTrimLineInsteadOfModelCode ? trimLine : selectedModel;
    var models = data.models,
      headingText = data.headingText,
      msrpLabel = data.msrpLabel;
    var defaultCarousel = data || {};
    var _models$filter = models.filter(function (model) {
        return selectedItem === (isTrimLineInsteadOfModelCode ? model.trimLine : model.code);
      }),
      _models$filter$ = _models$filter[0],
      newCarousel = _models$filter$ === void 0 ? defaultCarousel : _models$filter$;
    var _newCarousel$carousel = newCarousel.carousel,
      carousel = _newCarousel$carousel === void 0 ? {} : _newCarousel$carousel;
    var sortedModels = hasModelsOrdering ? ModelSelector.sortByCustomOrder(models) : ModelSelector.sortByPrice(models);
    var modelSelectorData = {
      models: sortedModels,
      headingText: headingText,
      msrpLabel: msrpLabel,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].stepContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configurator["default"].loaderWrapper
    }, carousel.items && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme.marginBottom40,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement(_configuratorModelSelector.ConfiguratorModelSelector, {
      theme: theme,
      market: market,
      data: modelSelectorData,
      changeEvent: this.changeEvent,
      selectedModel: selectedItem,
      isTrimLineInsteadOfModelCode: isTrimLineInsteadOfModelCode
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer))), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-offset-1'] + " " + theme['col-md-10']
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    }))));
  };
  return ModelSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    model: state.model.value,
    trimLine: state.trimLine.value,
    fuelType: state.fuelType.value,
    driveType: state.driveType.value,
    transmissionType: state.transmissionType.value,
    preferences: props.preferences,
    theme: props.theme,
    data: props.data
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ModelSelector);
exports["default"] = _default;